import React from 'react';
import {
  BANDS_DJS_TAXONOMY_KEY,
  BAR_SERVICES_TAXONOMY_KEY,
  CAKES_DESSERTS_TAXONOMY_KEY,
  CATERING_TAXONOMY_KEY,
  FLORISTS_TAXONOMY_KEY,
  HAIR_MAKEUP_TAXONOMY_KEY,
  PHOTOGRAPHERS_TAXONOMY_KEY,
  PLANNERS_TAXONOMY_KEY,
  SEARCHABLE_VENDOR_TAXONOMY_KEYS,
  SearchableVendorTaxonomyKey,
  VENUES_TAXONOMY_KEY,
  VIDEOGRAPHERS_TAXONOMY_KEY,
} from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { getVendorWordPill } from '@zola-helpers/client/dist/es/marketplace/vendorWords';
import { getVendorTaxonomySwitchFunc } from '@zola-helpers/client/dist/es/marketplace/vendorUtils';
import BandsDjsTile from './assets/bands-djs-tile.jpg';
import BarServicesTile from './assets/bar-services-tile.jpg';
import CakesDessertsTile from './assets/cakes-desserts-tile.jpg';
import CateringTile from './assets/catering-tile.jpg';
import FloristsTile from './assets/florists-tile.jpg';
import HairMakeupTile from './assets/hair-makeup-tile.jpg';
import PhotographersTile from './assets/photographers-tile.jpg';
import PlannersTile from './assets/planners-tile.jpg';
import VenuesTile from './assets/venues-tile.jpg';
import VideographersTile from './assets/videographers-tile.jpg';
import { CategoryTiles, TileImage, TileLink, TileName } from './VendorsCategoryTiles.styles';

const getTileImage = (taxonomyKey: SearchableVendorTaxonomyKey) =>
  getVendorTaxonomySwitchFunc({
    [BANDS_DJS_TAXONOMY_KEY]: BandsDjsTile,
    [BAR_SERVICES_TAXONOMY_KEY]: BarServicesTile,
    [CAKES_DESSERTS_TAXONOMY_KEY]: CakesDessertsTile,
    [CATERING_TAXONOMY_KEY]: CateringTile,
    [FLORISTS_TAXONOMY_KEY]: FloristsTile,
    [HAIR_MAKEUP_TAXONOMY_KEY]: HairMakeupTile,
    [PHOTOGRAPHERS_TAXONOMY_KEY]: PhotographersTile,
    [PLANNERS_TAXONOMY_KEY]: PlannersTile,
    [VENUES_TAXONOMY_KEY]: VenuesTile,
    [VIDEOGRAPHERS_TAXONOMY_KEY]: VideographersTile,
  })(taxonomyKey);

export type VendorsCategoryTilesProps = React.HTMLAttributes<HTMLUListElement> & {
  categories?: SearchableVendorTaxonomyKey[];
  openInNewTab?: boolean;
  onLinkClick?: () => void | null;
};

export const VendorsCategoryTiles = ({
  categories = SEARCHABLE_VENDOR_TAXONOMY_KEYS,
  openInNewTab = false,
  onLinkClick = () => null,
  className,
}: VendorsCategoryTilesProps): JSX.Element => {
  const linkProps = { target: openInNewTab ? '_blank' : undefined };
  return (
    <CategoryTiles className={className}>
      {categories.map((taxonomyKey) => {
        const url = `/wedding-vendors/${taxonomyKey}`;
        const name = getVendorWordPill(taxonomyKey);
        return (
          <li key={taxonomyKey}>
            <TileLink href={url} onClick={onLinkClick} noTextTransform noUnderline {...linkProps}>
              <TileImage src={getTileImage(taxonomyKey)} alt={name} />
              <TileName>{name}</TileName>
            </TileLink>
          </li>
        );
      })}
    </CategoryTiles>
  );
};

export default VendorsCategoryTiles;
